// extracted by mini-css-extract-plugin
module.exports = {"page_container":"style_page_container__B8GR7","desktop_padding_top":"style_desktop_padding_top__7y414"};